import React, {PureComponent} from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Button,
  Chip
} from "@material-ui/core";
import { withTheme } from "@material-ui/core/styles";


class UserInfoTabe extends PureComponent{
  constructor(props){
    super(props)
  }

  openInNewTab(url) {
    window.open(url, "_blank", "noopener,noreferrer");
  } 

  render(){
      const { theme, user } = this.props;
      if(!user){
        return <Box style={theme.table.empty}>No se encontraron datos del usuario</Box>
      }
      const {
        proTags = [],
        proInstagram = "",
        proDNI = "",
        proName = "",
        proEmail = "",
        proLastName = "",
        proPhone = "",
      } = user;
      return (
            <Table
              stickyHeader
              style={{
                minWidth: 500,
                boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.23)",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Nombre
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Apellido
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Instagram
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Telefono
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Email
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Documento
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f6f6f6" }}>
                    Tags
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{proName}</TableCell>
                  <TableCell>{proLastName}</TableCell>
                  <TableCell>
                    <Button
                      style={{ backgroundColor: "aquamarine" }}
                      onClick={() =>
                        this.openInNewTab(`https://instagram.com/${proInstagram}`)
                      }
                    >
                      {proInstagram}
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      style={{ backgroundColor: "aquamarine" }}
                      onClick={() =>
                        this.openInNewTab(
                          `https://api.whatsapp.com/send/?phone=549${proPhone}`
                        )
                      }
                    >
                      {proPhone}
                    </Button>
                  </TableCell>
                  <TableCell>{proEmail}</TableCell>
                  <TableCell>{proDNI}</TableCell>
                  <TableCell>
                    {proTags.map((t) => (
                      <Chip
                        label={t.tagName}
                        style={{ backgroundColor: t.tagColor, color:theme.palette.getContrastText(t.tagColor) }}
                      />
                    ))}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
      );
    }
  
}

export default withTheme(UserInfoTabe)


// WEBPACK FOOTER //
// ./src/components/UserInfo/UserInfoTable.js